<template>
    <div :class="['page already',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content">
            <p>Hi, your mobile phone number is already registered with us.  There's no need to register again.</p>
            <p>Watch out for great offers being sent to your mobile via text.</p>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions } from 'vuex';

export default {
    name: 'already',
    mixins: [ pageOn ],
    components: {
        VHeader
    }
}

</script>

<style lang="scss">
.already {
    p { font-size: 36px; text-align: center; width: calc(100% - 30px); margin: 10px; }
    p:nth-child(2) { margin-top: 40px; }

}
</style>